<template>
    <div class="align-self-center card bg-light" :style="frame">
        <Header ref="header" />
        <main class="page-view bg-light">
            <router-view />
        </main>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '../../components/v2/Header.vue';

export default {
    name: "BaseContainer",
    components: { Header },
    computed: {
        ...mapState(['maxWidth']),
        frame() {
            return {
                height: `${this.$screen.height}px`,
                maxWidth: `${this.maxWidth}px`,
                width: '100%'
            };
        },
    },
}
</script>

<style scoped>
.page-view {
    position: relative;
    height: 100%;
}
</style>